<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
export default {

  name: 'App',

};
</script>

<style lang="stylus">
#app
  background-color: #D0DFFE;

$color-pack = false
@import '~vuetify/src/stylus/app'
</style>
